import * as React from 'react';
import { useStyles } from '@sravni/react-utils';
import { Checkbox } from '../../Checkbox/src/Checkbox.js';
import { Radio } from '../../Radio/src/Radio.js';
import { Space } from '../../Space/src/Space.js';
import { Switch } from '../../Switch/src/Switch.js';
import modules_6b210db9 from '../styles/Menu.module.less.js';

const ChildrenWrapper = (args) => {
    const { children, ...props } = args;
    return React.cloneElement(children, props);
};
/**
 * @description Menu Item component.
 *
 * @component
 * @example
 * ```jsx
 * <Menu.Item hint="hint">Content</Menu.Item>
 * ```
 */
const MenuItem = React.forwardRef((props, ref) => {
    const { value, icon, control, hint, description, active, disabled, className, children, ...restProps } = props;
    const cx = useStyles(modules_6b210db9);
    const classNames = cx(className, 'item-base', 'item', {
        active,
        disabled,
    });
    const iconClassNames = cx(className, 'icon', {
        disabled,
    });
    const controlClassNames = cx(className, 'control', {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        'control-indent': description || icon,
        disabled,
    });
    const descriptionClassNames = cx(className, 'description', {
        disabled,
    });
    const controlElement = React.useMemo(() => {
        // @ts-ignore
        if (control && (control.type === Radio || control.type === Checkbox || control.type === Switch)) {
            const inputProps = {
                value,
                disabled,
                checked: active,
                readOnly: true,
            };
            return React.createElement(ChildrenWrapper, { ...inputProps }, control);
        }
        return control;
    }, [control, value, disabled, active]);
    return (React.createElement(Space, { ref: ref, align: "center", size: 12, className: classNames, ...restProps },
        icon && React.createElement("div", { className: iconClassNames }, icon),
        React.createElement(Space, { direction: "vertical", align: "start", size: 0 },
            hint && React.createElement("div", { className: descriptionClassNames }, hint),
            React.createElement("div", { className: cx('text') }, children),
            description && React.createElement("div", { className: descriptionClassNames }, description)),
        control && React.createElement("div", { className: controlClassNames }, controlElement)));
});
MenuItem.defaultProps = {};
MenuItem.displayName = 'MenuItem';

export { MenuItem };
//# sourceMappingURL=MenuItem.js.map
